"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.persistor = exports.store = void 0;
const redux_1 = require("redux");
// eslint-disable-next-line import/no-extraneous-dependencies
const redux_devtools_extension_1 = require("redux-devtools-extension");
const redux_persist_1 = require("redux-persist");
const autoMergeLevel1_1 = __importDefault(require("redux-persist/es/stateReconciler/autoMergeLevel1"));
const storage_1 = __importDefault(require("redux-persist/lib/storage"));
const redux_saga_1 = __importDefault(require("redux-saga"));
const redux_socket_io_1 = __importDefault(require("redux-socket.io"));
const socket_io_client_1 = __importDefault(require("socket.io-client"));
const utils_1 = require("~/utils");
const utils_2 = require("~/utils/utils");
const projectSharing_1 = require("~/utils/projectSharing");
const events_1 = require("~/utils/events");
const actions_1 = require("./actions");
const sagas_1 = __importDefault(require("./sagas"));
const reducers_1 = __importDefault(require("./reducers"));
const types_1 = require("./types");
const RECONNECTION_ATTEMPTS = 3;
let reconnectionCount = 0;
/* ------------- socketIO config ---------------*/
const io = (0, socket_io_client_1.default)(process.env.API_HOSTNAME, {
    reconnection: true,
    reconnectionDelay: 20000,
    reconnectionAttempts: RECONNECTION_ATTEMPTS,
});
io.on('connect', () => {
    reconnectionCount = 0;
    utils_1.Events.setWSConnectionStatus(types_1.LOADING_STATE.WS_CONNECTED);
    console.log(`connect ${reconnectionCount}`);
});
io.on('connect_error', () => {
    reconnectionCount++;
    if (reconnectionCount >= RECONNECTION_ATTEMPTS) {
        utils_1.Events.setWSConnectionStatus(types_1.LOADING_STATE.WS_DISCONNECTED);
    }
    else {
        utils_1.Events.setWSConnectionStatus(types_1.LOADING_STATE.WS_CONNECTION_ERROR);
    }
    console.log(`connect_error ${reconnectionCount}`);
});
io.on('reconnect_attempt', () => {
    reconnectionCount++;
    utils_1.Events.setWSConnectionStatus(types_1.LOADING_STATE.WS_RECONNECTING);
    console.log(`reconnect_attempt ${reconnectionCount}`);
});
io.on('reconnect', () => {
    utils_1.Events.setWSConnectionStatus(types_1.LOADING_STATE.WS_RECONNECTED);
    reconnectionCount = 0;
    console.log(`reconnect ${reconnectionCount}`);
});
io.on('disconnect', () => {
    if (reconnectionCount >= RECONNECTION_ATTEMPTS) {
        utils_1.Events.setWSConnectionStatus(types_1.LOADING_STATE.WS_DISCONNECTED);
    }
    else {
        utils_1.Events.setWSConnectionStatus(types_1.LOADING_STATE.WS_RECONNECTING);
    }
    console.log(`disconnect ${reconnectionCount}`);
});
const socketIoMiddleware = (0, redux_socket_io_1.default)(io, 'socket/');
/* ------------- Redux Configuration ------------- */
const rootReducer = (0, reducers_1.default)();
const middleware = [];
const enhancers = [];
/* ------------- Saga Middleware ------------- */
const sagaMiddleware = (0, redux_saga_1.default)();
middleware.push(sagaMiddleware);
/* ------------- Socket Middleware --------------- */
const socketAuthenticationMiddleware = (api) => {
    const handle = socketIoMiddleware(api);
    return (next) => {
        const send = handle(next);
        return (action) => {
            var _a, _b;
            if (!((_a = action.type) === null || _a === void 0 ? void 0 : _a.startsWith('socket/'))) {
                return send(action);
            }
            const row = Array.isArray(action.payload) ? action.payload[0] : action.payload;
            return send(Object.assign(Object.assign({}, action), { credentials: {
                    accessToken: (0, utils_2.getToken)(),
                    refreshToken: (0, utils_2.getRefreshToken)(),
                    shareToken: (0, projectSharing_1.getProjectShareToken)((_b = row === null || row === void 0 ? void 0 : row.projectId) !== null && _b !== void 0 ? _b : row === null || row === void 0 ? void 0 : row.id),
                } }));
        };
    };
};
middleware.push(socketAuthenticationMiddleware);
/* ------------- Assemble Middleware ------------- */
enhancers.push((0, redux_1.applyMiddleware)(...middleware));
const mergeOrInvalidateStateReconciler = (inboundState, originalState, reducedState) => {
    if (inboundState.user &&
        window.location.search.substring(1) !== 'logout' &&
        process.env.REACT_APP_VERSION === inboundState.user.version) {
        // eslint-disable-next-line no-use-before-define
        return (0, autoMergeLevel1_1.default)(inboundState, originalState, reducedState, persistConfig);
    }
    console.info('App version changed: Purging redux-persist state');
    return originalState;
};
const persistConfig = {
    key: 'root',
    storage: storage_1.default,
    stateReconciler: mergeOrInvalidateStateReconciler,
};
const persistedReducer = (0, redux_persist_1.persistReducer)(persistConfig, rootReducer);
const store = (0, redux_1.createStore)(persistedReducer, (0, redux_devtools_extension_1.composeWithDevTools)(...enhancers));
exports.store = store;
const persistor = (0, redux_persist_1.persistStore)(store);
exports.persistor = persistor;
io.on('project-access-error', ({ message }) => {
    store.dispatch((0, actions_1.requestBOMFail)(message));
    store.dispatch((0, actions_1.setViewMode)('view'));
    document.body.dispatchEvent((0, events_1.dispatchNotificationEvent)({ message, type: 'error' }));
});
// Kick off root sagas
sagaMiddleware.run(sagas_1.default);
